import React, { forwardRef } from 'react';

import type { InputBaseProps } from '@mui/material';
import { InputBase } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

interface PermissionRoleInputProps extends InputBaseProps {
  open: boolean;
}

const useStyles = makeStyles<Pick<PermissionRoleInputProps, 'open'>>()((theme, { open }) => ({
  input: {
    boxSizing: 'border-box',
  },
  root: {
    color: open ? theme.palette.primary.main : undefined,
  },
}));

/**
 * Note we must spread ...rest for the input to render as Material-UI injects props.
 */
const PermissionRoleInputWithRef = forwardRef(function FontStyleInput(
  props: PermissionRoleInputProps & { notched?: boolean },
  ref
): JSX.Element {
  // Filter out `notched` prop that MUI Select passes but causes DOM warning
  const { notched, open, ...rest } = props;
  const { classes } = useStyles({ open });
  return <InputBase ref={ref} classes={classes} {...rest} />;
});

export const PermissionRoleInput = React.memo(PermissionRoleInputWithRef);
